import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { DateRangePicker, SingleDatePicker } from 'react-dates';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';
import Select from 'react-select';
import { renderField, required } from '../../../forms';

export const renderBootstrapField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <InputGroup>
    { label && (<ControlLabel>{label}</ControlLabel>)}
    <FormControl
      {...input}
      type={type}
    />
    {touched &&
      ((error && <span>{error}</span>) ||
        (warning && <span>{warning}</span>))}
  </InputGroup>
);

const renderNoteField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <FormGroup>
    <ControlLabel>Notes</ControlLabel>
    <FormControl
      {...input}
      componentClass="textarea"
      name="note"
      placeholder="Add a note about the event. This note is visible to participants."
    />
  </FormGroup>
);

const RenderSelectInput = ({input, options, name, id, label}) => (
  <FormGroup>
    <ControlLabel>{label}</ControlLabel>
    <Select
      id={id}
      name={name}
      options={options}
      value={input.value}
      onChange={(value) => input.onChange(value.value)}
      onBlur={(value) => input.onBlur(value.value)}
    />
  </FormGroup>
);

const AgencyEditForm = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  const saveLabel = 'Save';

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <FormGroup>
          <Field
            name="name"
            type="text"
            component={renderBootstrapField}
            label="Name"
            validate={[required]}
          />
        </FormGroup>
        <FormGroup>
          <Field
            name="iata"
            type="text"
            component={renderBootstrapField}
            label="IATA"
          />
        </FormGroup>
        <FormGroup>
          <ButtonToolbar>
            <Button
              disabled={pristine || submitting}
              bsStyle="info"
              type="submit"
            >
              <i className="fa fa-pencil fa-lg" /> {saveLabel}
            </Button>
          </ButtonToolbar>
        </FormGroup>
      </form>
    </div>
  );
};

export default reduxForm({
  form: 'AgencyEditForm', // a unique identifier for this form
})(AgencyEditForm);



// WEBPACK FOOTER //
// src/routes/agency/components/AgencyEditForm.js